import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import swal from 'sweetalert';

import axios from '../../../services/MyAxios';

import { CASINO_FREESPIN_PAGES } from '../Helpers/CrmUrls';

import FreespinPageForm from './FreespinPageForm';

function FreespinPageEdit() {
    const [errors, setErrors] = useState([]);
    const history = useHistory();
    const { id } = useParams();

    const handleSubmit = (bonusPage) => {
        axios
            .put(`/crea/casino/api/freespin-pages/${id}`, bonusPage)
            .then((response) => {
                if (response.data) {
                    swal({
                        title: 'Success',
                        text: 'Freespin page updated correctly',
                        icon: 'success',
                    }).then(() => {
                        history.push(CASINO_FREESPIN_PAGES);
                    });
                }
            })
            .catch((error) => {
                if (!error.response) {
                    setErrors(error.message);
                } else if (error.response.status !== 500) {
                    setErrors(error.response.data.errors);
                } else {
                    swal({
                        title: 'Error',
                        text: 'Server error',
                        icon: 'error',
                    });
                }
            });
    };

    return <FreespinPageForm bonusPageId={parseInt(id)} handleSubmit={handleSubmit} errors={errors} />;
}

export default FreespinPageEdit;
